import { FC, ReactNode } from 'react';
import styles from './PunchupFeed.module.css';

export interface PunchupFeedProps {
	children: ReactNode;
	className?: string;
}

export const PunchupFeed: FC<PunchupFeedProps> = ({ children, className }) => (
	<div className={[styles.root, className].filter(Boolean).join(' ')}>{children}</div>
);
